export function catColors(cat) {
  if (cat === 'Video')    return { from: 'rgba(99,102,241,.45)',  to: 'rgba(167,139,250,.22)', ring: 'rgba(99,102,241,.45)', label: '#A5B4FC' };
  if (cat === 'Text')     return { from: 'rgba(16,185,129,.35)',  to: 'rgba(16,185,129,.12)',  ring: 'rgba(16,185,129,.4)',  label: '#6EE7B7' };
  if (cat === 'Workflow') return { from: 'rgba(167,139,250,.42)', to: 'rgba(99,102,241,.18)',  ring: 'rgba(167,139,250,.4)', label: '#C4B5FD' };
  return                         { from: 'rgba(255,126,103,.42)', to: 'rgba(255,77,141,.18)',  ring: 'rgba(255,77,141,.45)', label: '#FFC2B5' };
}
